import { render } from "./myLess.vue?vue&type=template&id=f8d7a242&scoped=true"
import script from "./myLess.vue?vue&type=script&lang=js"
export * from "./myLess.vue?vue&type=script&lang=js"

import "./myLess.vue?vue&type=style&index=0&id=f8d7a242&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d7a242"]])

export default __exports__